var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { __, sprintf } from "@wordpress/i18n";
import { AppContext } from "../../../../../providers/AppContextProvider";
import { CustomFieldEntityType, } from "../../../../../types/custom-field";
import { WPQTIconButton } from "../../../../common/Button/Button";
import { Loading } from "../../../../Loading/Loading";
function CustomFieldActions({ data, onSave, locationOfCustomFields, onDelete, actionLoading, }) {
    const { state: { isUserAllowedToDelete }, } = useContext(AppContext);
    const isAllowedToDelete = data.entity_type === locationOfCustomFields;
    const isAllowedToSave = locationOfCustomFields === CustomFieldEntityType.Task ||
        locationOfCustomFields === CustomFieldEntityType.User;
    const entityTypeDisplay = data.entity_type === CustomFieldEntityType.Pipeline
        ? "board"
        : data.entity_type;
    const handleDelete = () => __awaiter(this, void 0, void 0, function* () {
        if (!isAllowedToDelete) {
            return;
        }
        onDelete();
    });
    if (actionLoading) {
        return _jsx(Loading, { ovalSize: "24" });
    }
    return (_jsxs("div", { className: "wpqt-flex wpqt-items-center wpqt-justify-center wpqt-gap-2", children: [isAllowedToSave && (_jsx(WPQTIconButton, { onClick: onSave, icon: _jsx(PencilSquareIcon, { className: "wpqt-icon-green wpqt-size-4" }), tooltipId: `custom-field-${data.id}-update`, tooltipText: __("Edit custom field value", "quicktasker") })), isUserAllowedToDelete && (_jsx(WPQTIconButton, Object.assign({ onClick: handleDelete, className: `${!isAllowedToDelete ? "!wpqt-cursor-not-allowed" : ""}`, icon: _jsx(TrashIcon, { className: "wpqt-icon-red wpqt-size-4" }) }, (!isAllowedToDelete && {
                tooltipId: `custom-field-${data.id}-delete`,
                tooltipText: sprintf(__("This custom field is inherited from %s settings and can't be deleted here", "quicktasker"), entityTypeDisplay),
            }))))] }));
}
export { CustomFieldActions };
